import { render, staticRenderFns } from "./GiftAlternative.vue?vue&type=template&id=438a5d91"
import script from "./GiftAlternative.vue?vue&type=script&lang=js"
export * from "./GiftAlternative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports